export const createConversationMock = ({
  contactFullName = 'Joe Doe',
  contactId = null,
  conversationId = null,
  messages = [],
  phoneNumbers = [],
  reservation = null,
  unread = false,
}) => ({
  contact: {
    emails: ['test@test.com'],
    full_name: contactFullName,
    id: contactId,
    phone_numbers: phoneNumbers,
    reservation,
  },
  id: conversationId,
  type_smessage_thread_status: {
    code: 'new',
    name: 'New',
  },
  messages,
  unread,
});

export const createContactMock = ({
  typeContact = {
    code: 'quest',
    name: 'Quest',
  },
  emails = [],
  fullName = 'Joe Doe',
  id = null,
  phoneNumbers = [],
  reservation = null,
}) => ({
  type_contact: typeContact,
  emails,
  full_name: fullName,
  id,
  phone_numbers: phoneNumbers,
  reservation,
});

export const createMessageMock = ({
  createdAt = '2018-07-17T19:32:15',
  messageId = null,
  messageText = 'Test message, lorem ipsum dolor sit amet.',
  user = {},
  sender = false,
}) => ({
  created_at: createdAt,
  id: messageId,
  message: messageText,
  sender,
  user,
});

export const createPhoneNumberMock = ({
  contactId = null,
  countryCode = 'us',
  dialCode = '1',
  id = null,
  phoneNumber = '1234567898',
}) => ({
  contact_id: contactId,
  id,
  dial_code: dialCode,
  phone_number: phoneNumber,
  country_code: countryCode,
});

export const createUser = ({
  active = true,
  email = 'test@test.com',
  fullName = 'Joe Doe',
  userId = null,
}) => ({
  id: userId,
  full_name: fullName,
  active,
  email,
});

export const createPhoneNumber = ({ id = null, phoneNumber = '6213232322' }) => ({
  country_code: 'us',
  phone_number: phoneNumber,
  id,
});
